import { render, staticRenderFns } from "./ViTeacherExamSchedule.vue?vue&type=template&id=7a4456aa"
import script from "./ViTeacherExamSchedule.vue?vue&type=script&lang=js"
export * from "./ViTeacherExamSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports